<ng-container *transloco="let t; read:'permit.returnDelegationConfirmation'">
    <div class="modal">
        <div class="modal__content">
            <div class="modal__content__question" [innerHTML]="t('question')"></div>
            <div *ngIf="errorMessage$ | async as errorMessage" class="modal__content__error">{{ errorMessage || t("error") }}</div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="close()">{{ t("cancel") }}</button>
            <button class="modal__actions__save" type="button" [loading]="SubscriptionsActions.ReturnCurrentUserDelegation" (click)="confirm()">{{ t("confirm") }}</button>
        </div>
    </div>
</ng-container>
